"use strict";

/**
 * Runs js code based on controller action.
 * Allows to have proper name spacing.
 */
const waApp = {
	debug: false,
	log: function(text) {
		if (waApp.debug === true) {
			console.log(text);
		}
	},
	language: null,
	controllers: function() {
		// init the controller object
	},
	getLanguage: function() {
		if (waApp.language !== null) {
			return waApp.language;
		}

		var regex = new RegExp("\/[a-z]{2}\/|\/[a-z]{2}$");
		var result = regex.exec(window.location.href);

		if (result === null) {
			return "en";
		}

		waApp.language = result[0].replace(/\//g, "");

		return waApp.language;
	},
	/**
	 * Runs before the application action is executed.
	 */
	init: function() {
		waGaEvents.gaEventCaller();
		waAdSpace.partnerLogos();
		setTimeout(function() {
			waAdSpace.manageAdSpace();
		}, 1000);
		waUtils.initValidations();
		waNavigation.burgerMenuAnimation();
		waNavigation.navBarSearch();
		waUtils.initFancyBox();

		$(".select2-enabled").select2();
		$("#nl-footer-form").validate();

		/* waCmp.init(); // old EU consent trigger */
		waIsotopGlobalGrids.init();
		waUtils.initFloatLabels();
		waFlashMessages.manageAlerts();
	},
	run: function(action) {
		this.init();

		function deepPropAccess(obj, prop) {
			return prop.split(".").reduce(function(o, k) {
				if (o === undefined) {
					return;
				}
				return o[k];
			}, obj);
		}

		let callable = (deepPropAccess(waApp.controllers, action));
		if (callable !== undefined) {
			callable();
			waApp.log(action + " called.");
		} else {
			waApp.log(action + " does not exist.");
		}
	}
};

/**
 * Translation library, make sure this gets executed very early and is NOT
 * wrapped in a document ready callback!
 */
i18next
	.use(window.i18nextXHRBackend)
	.init({
		lng: waApp.getLanguage(),
		fallbackLng: ["en"],
		defaultNs: "translation",
		backend: {
			loadPath: "/js/locales/{{lng}}/{{ns}}.json",
			crossDomain: false,
			requestOptions: {
				cache: "default"
			}
		},
		load: "languageOnly", // This ensures it tries 'en' instead of 'en-US'
		fallbackNS: false,
		saveMissing: false,
		debug: false,
		// Retry configuration
		retry: {
			attempts: 2,
			interval: 300
		}
	}, function(error, t) {
		if (error !== undefined) {
			// Log the error for debugging, but don't break the application
			if (waApp.debug) {
				waApp.log("i18next initialization error: " + error);
			}

			// If initialization failed completely, try to reinitialize with just English
			if (!i18next.isInitialized) {
				i18next.init({
					lng: "en",
					fallbackLng: ["en"],
					defaultNs: "translation",
					backend: {
						loadPath: "/js/locales/en/translation.json"
					},
					debug: false
				});
			}
		}
	});

